import React, { useEffect, useState } from "react";
import axios from "../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
} from "../../js/utility.js";
import Breadcrumb from "../utils/Breadcrumb.jsx";
import Select from "react-select";
import {
  Document,
  Page,
  Text,
  Image,
  StyleSheet,
  pdf,
} from "@react-pdf/renderer";

const ClassesLayout = () => {
  const [schools, setSchools] = useState([]);
  const [fullSchoolsData, setFullSchoolsData] = useState([]);
  const [classrooms, setClassrooms] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedSchoolProv, setSelectedSchoolProv] = useState(null);
  const [labelSelectedSchool, setLabelSelectedSchool] = useState(null);
  const [teacherSchools, setTeacherSchools] = useState([]);
  const prevSelectedSchool = window.location.href.split("/").pop();
  const currentMonth = new Date().getMonth();
  const schoolYear =
    currentMonth >= 8
      ? `${new Date().getFullYear()}${new Date().getFullYear() + 1}`
      : `${new Date().getFullYear() - 1}${new Date().getFullYear()}`;

  const role = localStorage.getItem("role");
  const teacherId = localStorage.getItem("userId");

  const breadcrumb = {
    current_section: "Gestione Classi",
    sections: [
      { name: "Scuole", route_name: null, params: [] },
      { name: "Gestione classi", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions("application/json", [], "GET");
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllSchools`,
          fetchOptions
        );
        const result = await response.json();

        if (result.error) {
          alert("Errore durante il caricamento delle scuole");
          console.error("Error fetching schools:", result.error);
          return;
        }

        const customresult = result.map((item) => {
          return {
            ...item,
            customTown: item.Town.nome + " (" + item.Province.codice + ")",
          };
        });

        setSchools(
          convertIntoSelect2Options(customresult, "id", [
            "codmiur",
            "denomistituto",
            "customTown",
          ])
        );

        setFullSchoolsData(result);

        if (!isNaN(parseInt(prevSelectedSchool, 10))) {
          setSelectedSchool(parseInt(prevSelectedSchool, 10));
          setLabelSelectedSchool(
            result.find((school) => school.id == prevSelectedSchool)
              ?.denomistituto
          );
        } else setSelectedSchool(null);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchTeacherSchools = async () => {
      try {
        const fetchOptions = getFetchOptions("application/json", [], "GET");
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getTeacherSchools?userId=${teacherId}`,
          fetchOptions
        );
        const result = await response.json();

        if (result.error) {
          alert("Errore durante il caricamento delle scuole");
          console.error("Error fetching schools:", result.error);
          return;
        }

        const customresult = result.map((item) => {
          return {
            ...item,
            customTown: item.Town.nome + " (" + item.Province.codice + ")",
          };
        });

        setSchools(
          convertIntoSelect2Options(customresult, "id", [
            "codmiur",
            "denomistituto",
            "customTown",
          ])
        );

        setFullSchoolsData(result);

        if (!isNaN(parseInt(prevSelectedSchool, 10))) {
          setSelectedSchool(parseInt(prevSelectedSchool, 10));
          setLabelSelectedSchool(
            result.find((school) => school.id == prevSelectedSchool)
              ?.denomistituto
          );
        } else setSelectedSchool(null);
      } catch (error) {
        console.error(error);
      }
    };

    if (role === "Admin") fetchSchools();
    if (role === "Insegnante") fetchTeacherSchools();
  }, []);

  useEffect(() => {
    if (role === "insegnante") {
      setSchools(
        schools.filter((school) =>
          teacherSchools.some((ts) => ts.idscuola === school.value)
        )
      );
    }
  }, [teacherSchools]);

  useEffect(() => {
    if (!selectedSchool) return;

    const fetchClasses = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllClasses?schoolId=${selectedSchool}&schoolYear=${schoolYear}`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          alert("Non ci sono classi per questa scuola");
          console.error("Error fetching classes:", result.error);
          return;
        }
        setClassrooms(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchClasses();
  }, [selectedSchool]);

  const handleSchoolChange = (e) => {
    if (!e?.value) {
      setClassrooms([]);
      setLabelSelectedSchool("");
      setSelectedSchool(null);
      setSelectedSchoolProv(null);
      return;
    }
    setLabelSelectedSchool(e?.label);
    setSelectedSchool(e?.value);
    setSelectedSchoolProv(
      fullSchoolsData.find((school) => school.id === e?.value)?.idprovincia
    );
  };

  // Function to handle QR code generation
  const styles = StyleSheet.create({
    page: {
      padding: 40,
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    qrImage: {
      width: 200,
      height: 200,
      marginBottom: 20,
    },
    text: {
      fontSize: 16,
      textAlign: "center",
    },
    textBold: {
      fontSize: 16,
      textAlign: "center",
      fontWeight: "bold",
    },
  });

  const QRCodePDF = ({ qrImageData, classId, classData }) => (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image
          style={{ width: 250, height: 40, marginBottom: 30 }}
          src="/assets/images/brand-logos/desktop-logo.png"
        />
        <Image style={styles.qrImage} src={qrImageData} />
        <Text style={styles.textBold}>
          Codice MIUR: {classData?.scuola.label.split("-")[0] + "\n"}
          {classData?.scuola.label.split("-")[1] +
            " - " +
            classData?.scuola.label.split("-")[2]}
        </Text>
        <Text style={styles.text}>
          QR Code per la classe {classData?.classe + " " + classData?.sezione}
        </Text>
      </Page>
    </Document>
  );

  const handleQrCodeGeneration = async (classId) => {
    let classData = classrooms.find(
      (classroom) => classroom.idclassi === classId
    );

    classData.scuola = schools.find(
      (school) => school.value === classData.idscuola
    );

    try {
      const fetchOptions = getFetchOptions(
        "application/x-www-form-urlencoded",
        [],
        "GET"
      );

      const response = await fetch(
        `${axios.defaults.baseBFFUrl}/app/generateQrCode?schoolId=${selectedSchool}&classId=${classId}&cityId=${selectedSchoolProv}`,
        fetchOptions
      );

      if (!response.ok) {
        throw new Error("Failed to fetch QR code");
      }

      const blob = await response.blob();
      const qrImageData = await blobToBase64(blob);

      const pdfBlob = await pdf(
        <QRCodePDF
          qrImageData={qrImageData}
          classId={classId}
          classData={classData}
        />
      ).toBlob();

      // DOWNLOAD DIRETTO DEL PDF
      const url = URL.createObjectURL(pdfBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `QRCode_Classe_${
        classData?.classe + "_" + classData?.sezione
      }.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating QR code PDF:", error);
    }
  };

  const blobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

  const handleDeleteClass = async (classId) => {
    try {
      const fetchOptions = getFetchOptions(
        "application/x-www-form-urlencoded",
        [],
        "DELETE"
      );
      const response = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/deleteClass?classId=${classId}`,
        fetchOptions
      );

      if (response.error) {
        alert("Errore durante l'eliminazione della classe");
        console.error("Error deleting class:", response.error);
        return;
      }

      setClassrooms((prevClassrooms) =>
        prevClassrooms.filter((item) => item.idclassi !== classId)
      );
    } catch (error) {
      console.error("Error deleting class:", error);
    }
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      {/* School Selection */}
      <div className="card custom-card">
        <div className="card-header">Gestione classi</div>
        <div className="card-body">
          <Select
            options={schools}
            id="school"
            name="school"
            value={schools?.filter(function (option) {
              return option.value === selectedSchool;
            })}
            onChange={handleSchoolChange}
            classNames={"form-control"}
            placeholder="Scegli scuola..."
            isSearchable
            isClearable
          />
        </div>
      </div>

      {/* Classrooms Detail */}
      {selectedSchool && (
        <div className="card custom-card" id="classroomDetail">
          <div className="card-header">
            <div className="d-flex justify-content-between align-items-center w-100">
              <div>{labelSelectedSchool}</div>
              <div>
                <div className="d-flex justify-content-end">
                  <button
                    onClick={() => {
                      window.location.href = `/classes/add/${selectedSchool}`;
                    }}
                    type="button"
                    className="btn btn-primary text-uppercase"
                  >
                    <i className="bi bi-plus-circle-fill"></i> Nuovo
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered" id="datatable-basic">
                <thead>
                  <tr>
                    <th>Classe</th>
                    <th>Sezione</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {classrooms.map((item, index) => (
                    <tr key={index}>
                      <td>{item.classe}</td>
                      <td>{item.sezione}</td>
                      <td width={"20%"}>
                        <div className="btn-list">
                          <button
                            className="btn btn-sm btn-warning"
                            onClick={() => {
                              window.location.href = `/classes/edit/${item.idclassi}`;
                            }}
                          >
                            <i className="align-middle bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Sei sicuro di voler eliminare questa classe?"
                                )
                              ) {
                                handleDeleteClass(item.idclassi);
                              }
                            }}
                          >
                            <i className="align-middle bi bi-trash"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-info"
                            onClick={() => {
                              window.location.href = `/classes/detail/${item.idclassi}`;
                            }}
                          >
                            <i className="align-middle bi bi-eye"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => {
                              handleQrCodeGeneration(item.idclassi);
                            }}
                          >
                            <i className="align-middle bi bi-qr-code"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClassesLayout;
